import ProductDescription from './ProductDescription'

const BSOatsOatmealProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '005BS',
  IsBroadband: true,
  OatType: '',
  OtherType: null,
  Size: '',
  Variety: '',
  OtherVariety: null,
  CookingType: '',
}

export default BSOatsOatmealProduct
